/* System defined core library */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components/BaseClass */
import { MaxLengthClass } from '../../../../shared/baseclass/max-length.class';
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';

/* User defined models */
import { AppointmentSearch } from '../../../../shared/models/scheduling/appointmentSearch.model';


@Component({
  selector: 'app-appointment-lookup-form',
  templateUrl: './appointment-lookup-form.component.html',
  styleUrls: ['./appointment-lookup-form.component.scss']
})
export class AppointmentLookupFormComponent extends MaxLengthClass implements OnInit {

  /* User defined private/public variables  */
  public appointmentlookupFrm: FormGroup;
  public errorMessage: string = "";
  public appointmentSearch: AppointmentSearch;
  public maxlengthLastname: number;
  public isSubmitInProgress: boolean = false;

  /* Input-OutPut parameters decalartions */
  @Output() public submittedForm: EventEmitter<AppointmentSearch> = new EventEmitter();
  @Input() public hasErrorOccuredInParent: boolean;
  @Input() public eligibilityErrorOccuredInParent: boolean;
  @Input() public linkToIWR: string;
  @Input() public programNotPublished: boolean = false;

  /* Service subscriptions */
  appointmentSearch$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private fb: FormBuilder,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {
    super();

    this.appointmentSearch$ = selectedExamDetailService.appointmentSearch.subscribe(
      appointmentSearch => {
        this.appointmentSearch = appointmentSearch;
      });

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    );
  }

  /* Call first time on page load */
  ngOnInit() {
    this.appointmentlookupFrm = this.fb.group({
      'confirmationNumber': new FormControl('', Validators.required),
      'lastName': new FormControl('', Validators.required),
    });
    if (!this.selectedExamDetailService.isSearchPerformed) {
      this.appointmentSearch = new AppointmentSearch("", "", "");
    }
  }

  submit(appointmentSearch: AppointmentSearch): void {
    if (this.isSubmitInProgress) return;
    this.isSubmitInProgress = true;
    this.submittedForm.emit(this.appointmentSearch);
  }

  isDisable(): boolean {
    return !this.appointmentlookupFrm.valid || this.isSubmitInProgress;
  }
}